// ** Redux Imports
/* eslint-disable */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { commissionsByRole } from "../../../../api/Api";

export const getAllCommissionByRole = createAsyncThunk(
  "appCommission/getAllCommissionByRole",
  async (query) => {
    try {
      return commissionsByRole.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getCommission = createAsyncThunk(
  "appCommission/getCommission",
  async (id) => {
    try {
      return commissionsByRole.getCommission(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const commissionActive = createAsyncThunk(
  "appCommission/commissionActive",
  async (value) => {
    return commissionsByRole.active(value);
  }
);

export const addCommission = createAsyncThunk(
  "appCommission/addCommission",
  async (values) => {
    try {
      return commissionsByRole.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const editCommission = createAsyncThunk(
  "appCommission/editCommission",
  async (values) => {
    return commissionsByRole.edit(values);
  }
);

export const deleteCommission = createAsyncThunk(
  "appCommission/deleteCommission",
  async (id) => {
    return commissionsByRole.remove(id);
  }
);

export const appCommissionSlice = createSlice({
  name: "appCommission",
  initialState: {
    commissionsByRole: [],
    metaData: {},
    commissionsByRoleFetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllCommissionByRole.fulfilled, (state, action) => {
      if (action.payload.status !== 200) {
        state.commissionsByRole = [];
        state.commissionsByRoleFetch = false;
        state.metaData = {};
        return;
      }
      state.metaData = action.payload?.data?.metaData;
      console.log("action.payload", action.payload);
      state.commissionsByRole = action.payload?.data?.data;
      state.commissionsByRoleFetch = true;
    });
  },
});

export default appCommissionSlice.reducer;
